function getHashRouteSearch() {
  if (typeof window === 'undefined') {
    return '';
  }

  const hash = window.location.hash.startsWith('#')
    ? window.location.hash.slice(1)
    : window.location.hash;
  const searchIndex = hash.indexOf('?');
  if (searchIndex < 0) {
    return '';
  }

  const routeHashIndex = hash.indexOf('#', searchIndex);
  return routeHashIndex >= 0
    ? hash.slice(searchIndex, routeHashIndex)
    : hash.slice(searchIndex);
}

function getTopLevelSearchParams() {
  if (typeof window === 'undefined') {
    return new URLSearchParams();
  }

  return new URLSearchParams(window.location.search);
}

function replaceWindowUrl(nextUrl: string) {
  if (typeof window === 'undefined') {
    return false;
  }

  const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  if (nextUrl === currentUrl) {
    return false;
  }

  window.history.replaceState(null, '', nextUrl);
  return true;
}

export function getCurrentRouteSearchParams() {
  if (typeof window === 'undefined') {
    return new URLSearchParams();
  }

  const hashSearch = getHashRouteSearch();
  return new URLSearchParams(hashSearch || window.location.search);
}

function getCurrentLinkParam(name: string) {
  const routeValue = getCurrentRouteSearchParams().get(name)?.trim()
  if (routeValue) {
    return routeValue
  }

  const topLevelValue = getTopLevelSearchParams().get(name)?.trim()
  return topLevelValue || ''
}

export function getCurrentLinkToken() {
  return getCurrentLinkParam('token')
}

export function getCurrentLinkUuid() {
  return getCurrentLinkParam('uuid')
}

export function stripCurrentLinkTokenFromUrl() {
  if (typeof window === 'undefined') {
    return false;
  }

  const currentUrl = new URL(window.location.href);
  let changed = false;

  if (currentUrl.searchParams.has('token')) {
    currentUrl.searchParams.delete('token');
    changed = true;
  }

  if (currentUrl.searchParams.has('uuid')) {
    currentUrl.searchParams.delete('uuid');
    changed = true;
  }

  if (currentUrl.searchParams.has('op_team')) {
    currentUrl.searchParams.delete('op_team');
    changed = true;
  }

  const hash = currentUrl.hash.startsWith('#')
    ? currentUrl.hash.slice(1)
    : currentUrl.hash;

  if (!hash) {
    return changed
      ? replaceWindowUrl(`${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`)
      : false;
  }

  const questionIndex = hash.indexOf('?');
  if (questionIndex < 0) {
    return changed
      ? replaceWindowUrl(`${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`)
      : false;
  }

  const hashPath = hash.slice(0, questionIndex);
  const hashSearch = hash.slice(questionIndex + 1);
  const hashParams = new URLSearchParams(hashSearch);

  if (hashParams.has('token')) {
    hashParams.delete('token');
    changed = true;
  }

  if (hashParams.has('uuid')) {
    hashParams.delete('uuid');
    changed = true;
  }

  if (hashParams.has('op_team')) {
    hashParams.delete('op_team');
    changed = true;
  }

  const nextHashSearch = hashParams.toString();
  currentUrl.hash = nextHashSearch ? `${hashPath}?${nextHashSearch}` : hashPath;

  return changed
    ? replaceWindowUrl(`${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`)
    : false;
}
